/**
 * Currency State Module
 */

/**
 * Basic check to see if a currency code is in a valid format
 * @param code
 */
export function isValid(code: any) {
    return code && typeof code === 'string' && code.length === 3;
}

export const COOKIE_NAME = 'content-currency';

// Hooks
export { useCurrencyCodes } from './hooks/useCurrencyCodes';
